import {
  cleanupExpiredTenantToken,
  refreshTenantTokenIfNeeded,
} from "../../reservation-widgets.js";

/**
 * Tenant reservation page loader (production).
 *
 * Loads the prebuilt reservation widget bundle from the configured
 * RESERVATION_WIDGET_URL. Contains no Vite/HMR/dev-server logic — the dev
 * variant lives in `tenant-page.dev.js` and is selected by webpack.config.js
 * when Encore is not running in production mode.
 */
(async function initTenantPage() {
  const root = document.getElementById("dr-tenant-app");
  if (!root) {
    return;
  }

  const widgetUrl = root.dataset.widgetUrl || "";
  const ssoToken = root.dataset.ssoToken || "";

  if (!ssoToken) {
    await refreshTenantTokenIfNeeded();
    cleanupExpiredTenantToken();
  }

  if (!widgetUrl) {
    console.error(
      "RESERVATION_WIDGET_URL is not configured. Please set this environment variable to load the tenant app."
    );
    root.innerHTML =
      '<div class="alert alert-warning">Widget nicht konfiguriert. Bitte setzen Sie RESERVATION_WIDGET_URL.</div>';
    return;
  }

  const widgetScript = document.createElement("script");
  widgetScript.type = "module";
  widgetScript.src = `${widgetUrl}?v=${Date.now()}`;
  document.head.appendChild(widgetScript);
})();
